import lazyLoad from '@utils/lazyLoad'
import code from '@enum/applicationCode'
const applicationCode = code.settings

const messageRoutes = [
  // 订单商品 商品列表
  {
    path: '/product/product-list',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/Product/product')),
    meta: {
      applicationCode,
      layoutMode: 'empty'
    }
  },
  // 订单商品 商品列表
  {
    path: '/product/product-list/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/Product/productDetail')),
    meta: {
      applicationCode,
      layoutMode: 'empty'
    }
  },
  // 订单商品 订单列表
  {
    path: '/order/order',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/Order/order'))
  },
  // 订单商品 订单详情
  {
    path: '/order/order/:id',
    exact: true,
    component: lazyLoad(() => import('@views/Setting/Order/orderDetail')),
    meta: {
      applicationCode,
      title: '订单详情'
    }
  },
  // 短信管理 商家端 通知短信
  {
    path: '/message/business/notice',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/notice'))
  },
  // 短信管理 商家端 营销短信
  {
    path: '/message/business/market',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/market'))
  },
  // 短信管理 商家端 短信报告
  {
    path: '/message/business/presentation',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/presentation'))
  },
  // 短信管理 商家端 模板列表
  {
    path: '/message/business/template',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/template'))
  },
  // 短信管理 商家端 签名列表
  {
    path: '/message/business/autograph',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/autograph'))
  },
  // 短信管理 商家端 短信账户
  {
    path: '/message/business/account',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Business/account'))
  },
  // 短信管理 运维端 签名审核
  {
    path: '/message/operation/autograph',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Operation/autograph'))
  },
  // 短信管理 运维端 模板审核
  {
    path: '/message/operation/template',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Operation/template'))
  },
  // 短信管理 运维端 账户管理
  {
    path: '/message/operation/account',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Operation/account'))
  },
  // 短信管理 运维端 通道管理
  {
    path: '/message/operation/channel',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Operation/channel'))
  },
  // 短信管理 运维端 变量管理
  {
    path: '/message/operation/variable',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Operation/variable'))
  },
  // 系统 管理中心 授权管理
  {
    path: '/message/management/authorization',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Management/authorization'))
  },
  // 系统 管理中心 审计查询
  {
    path: '/message/management/audit',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Management/audit'))
  },
  // 系统 管理中心 审计列表
  {
    path: '/message/management/auditList',
    exact: true,
    component: lazyLoad(() => import('@views/Message/Management/auditList'))
  }
]

export default messageRoutes
